import React from "react";
import { Images } from "lucide-react";
export default function GalleryThumbs({
  images = [],
  selected,
  onSelect,
  onOpen,
}) {
  if (!images.length) return null;
  const visibleImages = images.slice(0, 2);

  return (
    <div className="gallery-thumbs">
      {visibleImages.map((image) => (
        <button
          key={image.id}
          className={`gallery-thumb ${selected?.id === image.id ? "active" : ""
            }`}
          onClick={() => onSelect(image)}
        >
          <img
            src={image.url}
            alt=""
            loading="lazy"
          />
        </button>
      ))}

      {images.length > 2 && (
        <button
          className="gallery-more"
          onClick={onOpen}
        >
          <Images size={24} />

          <span>
            +{images.length - 2}
          </span>

          <small>مشاهده همه</small>
        </button>
      )}
    </div>
  );
}